import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgFlashlight = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21.57 16.572c.234 0 .43-.157.43-.391v-8.36c0-.234-.196-.39-.43-.39h-5a2.07 2.07 0 0 0-1.547.703A2.06 2.06 0 0 0 14.5 9.5v5c0 .521.198 1.001.523 1.368.38.43.936.703 1.547.703zm-1.263-.822h.86v-7.5h-.86zm-1.5-6.82v6.142H16.57A.585.585 0 0 1 16 14.5v-5c0-.304.265-.57.57-.57zM9.5 8.25c0 .235.195.43.43.43h2.5c.234 0 .39-.195.39-.43v-.82c0-.234-.156-.43-.39-.43h-2.5a.434.434 0 0 0-.43.43zm-5.82.821c-.938 0-1.68.743-1.68 1.68v2.5c0 .938.742 1.68 1.68 1.68h10c.234 0 .39-.196.39-.43v-5a.5.5 0 0 0-.047-.212.37.37 0 0 0-.343-.218zm8.89 1.5H3.68a.18.18 0 0 0-.13.05.18.18 0 0 0-.05.13v2.5c0 .064.022.104.05.13.026.028.066.05.13.05h8.89z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgFlashlight;
